module.exports = __webpack_public_path__ + "static_portal/img/training_profile.fab2e6ff.jpg";